/** Load Bootstrap only on routes that import this module (forms, product catalogs, etc.). */
import "bootstrap/dist/css/bootstrap.css";
